module.exports = __webpack_public_path__ + "img/45.13c0464c.jpg";